export default __webpack_public_path__ + "ef8a743.png";